import React, { useState, useEffect, useContext } from 'react';



import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card, Tabs } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';




function CurrencySetting(props) {

  let { type, isDebit } = props;

  const { api, userData, currencyData, settingData, companyId, refData, yearId, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [setting, setSetting] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['currency', 'setting']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  useEffect(() => {
    setSetting({
      mainCurrencyId: settingData.mainCurrencyId,
      secondaryCurrencyId: settingData.secondaryCurrencyId,
    })
  }, [isLoading]);

  // Currency Options
  const currencyOptions = currencyData?.map(item => ({
    value: item.id,
    label: item.name,
  }))

  const handleInputChange = (e, name) => {
    const value = e?.value || null;
    setSetting((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {

    if (!setting.mainCurrencyId) {
      toast.error('Please Select Currency')
      return;
    }

    setLoadingEffect(true);

    const data = {
      setting,
      companyId,
    }


    let res = await api.post(`/setting/edit`, data)
    if (res.data.status) {
      toast.success(res.data.message);
      const dataArray = ['setting']
      await refData(dataArray, companyId);
    }
    else {
      toast.error(res.data.message);
    }
    setLoadingEffect(false);
  }



  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

      <Spin spinning={loadingEffect} fullscreen />

      {isLoading &&
        <Loader />
      }

      {!isLoading &&
        <Card style={{ width: '600px' }}>

          <Row className="mb-4">
            <Col>
              <Form.Label>{contentLanguages.MainCurrency}<span style={{ color: 'red' }}>*</span></Form.Label>
              <Select
                options={currencyOptions}
                isSearchable={true}
                placeholder="Select currency"
                onChange={(e) => handleInputChange(e, 'mainCurrencyId')}
                value={currencyOptions.find(option => option.value === setting.mainCurrencyId) || []}
                required
              />
            </Col>
          </Row>


          <Row className="mb-4">
            <Col>
              <Form.Label>{contentLanguages.SecondaryCurrency}<span style={{ color: 'red' }}>*</span></Form.Label>
              <Select
                options={currencyOptions}
                isClearable={true}
                isSearchable={true}
                placeholder="Select currency"
                onChange={(e) => handleInputChange(e, 'secondaryCurrencyId')}
                value={currencyOptions.find(option => option.value === setting.secondaryCurrencyId) || []}
              />
            </Col>
          </Row>

          <Row>
            <Col md={5}>
            </Col>
            <Col md={6}>
              <Button style={{ backgroundColor: '#23576a', color: 'white' }} onClick={handleSubmit}>{contentLanguages.Save}</Button>
            </Col>
          </Row>
        </Card >
      }

    </div >


  )
}

export default CurrencySetting;
